<div class="banner">
    <img src="/assets/img/banner/2.jpg" alt="Banner">
</div>
<div class="container-fluid innerPageMenu">
    <div class="row">
        <div class="col-md-3">
            <nav id="secondary-navigation">
                <!-- Header -->
                <header class="header">
                    <h5>Glimpses</h5>
                </header>
                <!-- /Header -->
                <ul>
                    <!-- <li routerLinkActive="active">
                        <a routerLink="/glimpses/program" ><i class="fa fa-angle-right" aria-hidden="true"></i>  Academic Program</a>
                    </li> -->
                    <li routerLinkActive="active">
                        <a  routerLink="/glimpses/magazine" >School Magazine</a>
                    </li>
                </ul>
            </nav>
        </div>
        <div class="col-md-9">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>